<template>
    <div class="form-group">
        Content below this sentence will be visible only for Premium Users.
    </div>
</template>

<script>
export default {};
</script>
